(function () {
  'use strict';

  var params = new URLSearchParams(window.location.search);
  if (params.get('rabitat_gallery_debug') !== '1' && !window.RABITAT_PDP_GALLERY_DEBUG) {
    return;
  }

  window.RABITAT_PDP_GALLERY_DEBUG = true;

  function log(type, detail) {
    console.log('[PDP GALLERY][' + type + ']', detail || '');
  }

  log('INIT', 'Diagnostics enabled. Scroll the page vertically and watch for unexpected gallery mutations.');

  var lastWindowScrollY = window.scrollY || 0;
  var scrollLogTick = false;

  window.addEventListener(
    'scroll',
    function () {
      if (scrollLogTick) return;
      scrollLogTick = true;
      window.requestAnimationFrame(function () {
        scrollLogTick = false;
        var y = window.scrollY || 0;
        if (Math.abs(y - lastWindowScrollY) < 8) return;
        lastWindowScrollY = y;
        log('PAGE SCROLL', { scrollY: y });
      });
    },
    { passive: true }
  );

  window.addEventListener(
    'resize',
    function () {
      log('RESIZE', {
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
        visualViewportHeight: window.visualViewport ? window.visualViewport.height : null,
        visualViewportWidth: window.visualViewport ? window.visualViewport.width : null,
      });
    },
    { passive: true }
  );

  if (window.visualViewport) {
    window.visualViewport.addEventListener(
      'resize',
      function () {
        log('VISUAL VIEWPORT RESIZE', {
          height: window.visualViewport.height,
          width: window.visualViewport.width,
          offsetTop: window.visualViewport.offsetTop,
        });
      },
      { passive: true }
    );
  }

  function bindHeroViewportDebug(viewport) {
    if (!viewport || viewport.dataset.rabitatGalleryDebugBound === 'true') return;
    viewport.dataset.rabitatGalleryDebugBound = 'true';

    var lastScrollLeft = viewport.scrollLeft;
    viewport.addEventListener(
      'scroll',
      function () {
        if (viewport.scrollLeft === lastScrollLeft) return;
        lastScrollLeft = viewport.scrollLeft;
        log('GALLERY VIEWPORT SCROLL', { scrollLeft: viewport.scrollLeft });
      },
      { passive: true }
    );
  }

  function snapshotHeroImages() {
    return Array.prototype.map.call(
      document.querySelectorAll('[data-product-hero-track] .rabitat-product-page__hero-image'),
      function (img, index) {
        return {
          index: index,
          currentSrc: img.currentSrc || img.src,
          complete: img.complete,
          naturalWidth: img.naturalWidth,
        };
      }
    );
  }

  var lastImageSnapshot = JSON.stringify(snapshotHeroImages());

  function watchHeroMutations() {
    var track = document.querySelector('[data-product-hero-track]');
    if (!track || track.dataset.rabitatGalleryDebugObserved === 'true') return;
    track.dataset.rabitatGalleryDebugObserved = 'true';

    var viewport = document.querySelector('[data-product-hero-viewport]');
    bindHeroViewportDebug(viewport);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList' && mutation.target === track) {
          log('TRACK DOM REPLACED', {
            added: mutation.addedNodes.length,
            removed: mutation.removedNodes.length,
          });
        }

        if (mutation.type === 'attributes' && mutation.target.classList.contains('rabitat-product-page__hero-slide')) {
          log('SLIDE CLASS/ATTR CHANGE', {
            attribute: mutation.attributeName,
            value: mutation.target.getAttribute(mutation.attributeName),
          });
        }

        if (
          mutation.type === 'attributes' &&
          mutation.target.classList &&
          mutation.target.classList.contains('rabitat-product-page__hero-image')
        ) {
          log('IMAGE ATTR CHANGE', {
            attribute: mutation.attributeName,
            value: mutation.target.getAttribute(mutation.attributeName),
          });
        }
      });

      var nextSnapshot = JSON.stringify(snapshotHeroImages());
      if (nextSnapshot !== lastImageSnapshot) {
        lastImageSnapshot = nextSnapshot;
        log('IMAGE SNAPSHOT CHANGE', JSON.parse(nextSnapshot));
      }
    }).observe(track, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'src', 'srcset', 'sizes', 'loading', 'style', 'hidden'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchHeroMutations);
  } else {
    watchHeroMutations();
  }

  document.addEventListener('shopify:section:load', watchHeroMutations);
})();
